// @flow
import InformsExtended from './InformsExtended';

export default InformsExtended;
